import React, { useContext, useState, MouseEvent, FC } from 'react'
import { StyledChangePassword } from './ChangePassword.styled'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { TNLink } from '../components/TNLink'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { TNInput } from '../components/TNInput'
import { metrics } from '../../__styling'
import { StyledButtonGroup } from '../MainScreen/MainScreen.styled'
import { TNButton } from '../components/TNButton'
import {
    useChangePassword,
    useForgotPassword,
    validatePassword,
} from '../hooks/useChangePassword'
import { UserSettingProps } from '../UserSetting'

const { md } = metrics.thenightly.margins

export interface ChangePasswordForm {
    currentPassword: string
    newPassword: string
}
export interface ChangePasswordProps extends UserSettingProps {}

export const ChangePassword: FC<ChangePasswordProps> = ({ config }) => {
    const { wanUserId: userId, userEmail } = useSelector(
        (state: AppState) => state.authentication,
    )
    const { setToast, setMessageBanner, goBackToParent } =
        useContext(MyAccountContext)
    const [password, setPassword] = useState<ChangePasswordForm>({
        currentPassword: '',
        newPassword: '',
    })
    const [submitting, setSubmitting] = useState<boolean>(false)

    const { mutateAsync: changePassword } = useChangePassword({
        userId,
        currentPassword: password.currentPassword,
        newPassword: password.newPassword,
        email: userEmail!,
        passEncryptionKey: config.passEncryptionKey!,
    })

    const { mutateAsync: sendForgotPasswordEmail } = useForgotPassword({
        email: userEmail!,
    })

    async function onSubmit(e: MouseEvent<HTMLElement>) {
        e.preventDefault()
        setMessageBanner(undefined)
        if (submitting) return
        const validate = validatePassword(password)
        if (!validate.valid) {
            validate.message &&
                setMessageBanner({
                    text: validate.message,
                    type: 'error',
                })
        } else {
            setSubmitting(true)
            const res = await changePassword()
            setSubmitting(false)
            if (res.result) {
                setToast({
                    text: res.message,
                    type: 'success',
                    show: true,
                })
                goBackToParent(false)
            } else {
                setMessageBanner({
                    type: 'error',
                    text: res.message,
                })
            }
        }
    }

    async function onForgotPassword() {
        setMessageBanner(undefined)
        const res = await sendForgotPasswordEmail()
        if (res.result) {
            setToast({
                text: res.message,
                type: 'success',
                show: true,
            })
        } else {
            setMessageBanner({
                type: 'error',
                text: res.message,
            })
        }
    }

    function onCancel(e: MouseEvent<HTMLElement>) {
        e.preventDefault()
        goBackToParent(true)
    }

    return (
        <StyledChangePassword>
            <TNInput
                id="current-password"
                label="Current Password"
                type="password"
                onChange={(currentPassword) =>
                    setPassword({ ...password, currentPassword })
                }
                marginBottom={md}
                autoFocus={true}
            />
            <TNLink width={'fit-content'} onClick={onForgotPassword}>
                Forgot your password
            </TNLink>
            <TNInput
                id="new-password"
                label="New password"
                type="password"
                onChange={(newPassword) =>
                    setPassword({ ...password, newPassword })
                }
            />
            <StyledButtonGroup>
                <TNButton onClick={onCancel} btnType="muted">
                    CANCEL
                </TNButton>
                <TNButton
                    onClick={onSubmit}
                    btnType="primary"
                    disabled={submitting}
                >
                    SAVE
                </TNButton>
            </StyledButtonGroup>
        </StyledChangePassword>
    )
}
